import { NationsWs } from "./../../../@types/enums/utilities/NationsWs";
import { useAuth, useGet } from "@onefront/react-sdk";
import { CountryCode } from "../../../@types/enums/newcustomer/NewCustomerCountries";
import { generateHeaders } from "../../../utils/generate-headers";
import { useCurrentTenant } from "@drift/oneplatfront";

interface UtilitiesGetParamsFetch {
    params?: any;
    headers?: any;
}

interface UseGetNationData {
    (resourceName: keyof typeof NationsWs, nation?: keyof typeof CountryCode, lazy?: boolean): {
        data?: Array<any>;
        loading?: boolean;
        fetch: (fetchConfig?: UtilitiesGetParamsFetch) => Promise<any>;
        error: boolean;
        lazy?: boolean;
    };
}

export const useGetNation: UseGetNationData = (resourceName, countryCode = "IT", lazy = true) => {
    const { tenant } = useCurrentTenant(true);
    return useGet(`rnd:core:workspace-bff:api://v1/nations/${countryCode}/${resourceName}`, {
        headers: {
            ...generateHeaders(useAuth(), tenant?.itemId, tenant?.id)
        },
        lazy
    });
};
